import { BaseService } from './base'
import { APIPath } from '../constant'
import { CommonUtility } from '../common'

class ClaimList {
    getList(queryParams) {
        const payload = { ...queryParams }
        if (payload.OriginatorUserId === '' || payload.OriginatorUserId == null) {
            delete payload.OriginatorUserId
        }
        const params = CommonUtility.objectToParams(payload)
        return BaseService.get(`${APIPath.claimList}?${params}`)
    }

    getCustomerExtensive(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.customerExtensiveSearch}?${params}`)
    }

    bulkRemove(auditIds) {
        return BaseService.postExact(APIPath.claimRemoveBulk, auditIds)
    }
}

const ClaimListService = new ClaimList()
Object.freeze(ClaimListService)
export { ClaimListService }
